<template>
  <router-view />
</template>

<script>
export default {
  name: 'FrontOffices',
}
</script>
